import React from 'react';
import { Box, Button, Stack, Container, Grid, Paper, Typography,Avatar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
import Footer from '../components/Footer';

const LandingPage = () => {
    const theme = useTheme();  

  return (
    <>
    <Container maxWidth="xl" sx={{background:theme.palette.black[200]}}>
      <Box sx={{ flexGrow: 1, overflow: 'hidden', px: 3, py: 4 }}>
      {/* Header with logo, title, and buttons aligned to the right */}
      <Box sx={{
        display: 'flex', 
        justifyContent: 'space-between', // This spreads out the logo/title and the buttons
        alignItems: 'center', 
        marginBottom: 4
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Stack direction="column">
          <Avatar
            alt="Bizzence Logo"
            src="/images/Bizzence_demo.png"
            sx={{ width: 74, height:74, marginRight: 8 }}
          />
            <Typography variant="h6" color={theme.palette.white[100]}>
              Bizzence
            </Typography>
          </Stack>
          
          <Typography variant="h4" component="h2" gutterBottom sx={{ 
            fontWeight: 'bold', 
            color: theme.palette.common.white
          }}>
            Elevating Your Business Sense and Science.
          </Typography>
        </Box>
        <Box>
          <Button 
            variant="outlined" 
            component={RouterLink} 
            to="/login"
            sx={{ marginRight: 1,color:theme.palette.black[100],backgroundColor:theme.palette.white[100] }} // Adds a small margin between the buttons
          >
            Login
          </Button>
          <Button 
            variant="contained" 
           
            component={RouterLink} 
            to="/create_user"
            sx={{ color:theme.palette.white[100],backgroundColor:theme.palette.blue[900] }}
          >
            Register
          </Button>
        </Box>
      </Box>
    

        {/* Zigzag layout with images and text */}
        <Grid container spacing={4}>
  {/* Image on the left */}
  <Grid item xs={12} md={6}>
    <Paper elevation={3} sx={{ height: 400, overflow: 'hidden' }}>
      <img src="/images/fin_dashboard.png" 
          alt="Dashboard showing financial data"
          style={{ 
              width: '100%', // Makes the image take up 100% of the paper's width
              height: '100%', // Makes the image take up 100% of the paper's height
              objectFit: 'contain' // Ensures the image is fully visible without stretching
          }} 
      />
    </Paper>
  </Grid>

  {/* Text on the right */}
  <Grid item xs={12} md={6} display="flex" alignItems="center">
    <Box>
      <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', color:theme.palette.blue[700] }}>
        Empower Your Decisions with Data-Driven Insights
      </Typography>
      <Typography variant="h6" sx={{ my: 2, color:theme.palette.white[100] }}>
        Intuitive Visuals and Informed Strategies with BizzBoard
      </Typography>
      <Typography variant="subtitle1" paragraph sx={{ my: 2, color:theme.palette.blue[500] }}>
        Welcome to our advanced analytics dashboard, where clarity meets efficiency. 
        Unveil the story behind your data with our comprehensive suite of visualization tools.
      </Typography>
    </Box>
  </Grid>


          {/* Second row with text on the left */}
          <Grid item xs={12} md={6} display="flex" alignItems="center">
            <Box>
              <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold',color:theme.palette.blue[700] }}>
                Streamline Your Data Workflow with Ease
              </Typography>
              <Typography variant="h6" sx={{ my: 2, color:theme.palette.white[100] }}>
                Simplify ETL with BizzFlow
              </Typography>
              <Typography variant="subtitle1" paragraph sx={{color:theme.palette.blue[500]}}>
              Unleash the power of your data with our cutting-edge ETL platform. Seamlessly extract data 
              from Google Sheets, transform it with custom operations,
               model it to uncover patterns, and bring it to life with vivid visualizations.
              </Typography>
              {/* ... Additional text sections */}
            </Box>
          </Grid>
          
          {/* Image on the right */}
          <Grid item xs={12} md={6}>
            <Paper elevation={3} sx={{ height: 400, overflow: 'hidden' }}>
              <img src="/images/etl.png" 
                  alt="ETL Process Visualization"
                  style={{ 
                      width: '100%', 
                      height: '100%', 
                      objectFit: 'contain' 
                  }} 
              />
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
    <Paper elevation={3} sx={{ height: 400, overflow: 'hidden' }}>
      <img src="/images/line_graph.png" 
          alt="Dashboard showing financial data"
          style={{ 
              width: '100%', // Makes the image take up 100% of the paper's width
              height: '100%', // Makes the image take up 100% of the paper's height
              objectFit: 'contain' // Ensures the image is fully visible without stretching
          }} 
      />
    </Paper>
  </Grid>

  {/* Text on the right */}
  <Grid item xs={12} md={6} display="flex" alignItems="center">
    <Box>
      <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold',color:theme.palette.blue[700] }}>
      Collaborative Charting for the Modern Trader
      </Typography>
      <Typography variant="h6" sx={{ my: 2, color:theme.palette.white[100]}}>
        Engage in Real-Time Analysis and Peer Insights with BizzRoom
      </Typography>
      <Typography variant="subtitle1" paragraph sx={{color:theme.palette.blue[500]}}>
      Unlock the potential of collective intelligence with our real-time chart room. 
      Create a space where strategies unfold collaboratively, 
      allowing you and your peers to annotate, discuss, and predict market movements as they happen.
      </Typography>
    </Box>
  </Grid>

          {/* Continue adding rows as necessary for more zigzag content */}
        </Grid>
      </Box>
      
    </Container>
    <Footer/>
    </>
  );
};

export default LandingPage;
